var checkout = {};
var regular = {
	userName:/^[a-zA-Z0-9]{6,16}$/, //用户名
	//userPassword:/^[a-z0-9]{8,16}$/, //密码
    userPassword:/(?!^(\d+|[a-zA-Z]+|[~!@#$%^&*?]+)$)^[\w~!@#$%^&*?]{8,16}$/,
	code:/^\d{6}$/, //验证码
    bankAccount:/^\d{0,64}$/, //银行账户-数字且长度不能大于64位
    chinese:/^[\u4e00-\u9fa5]{0,64}$/, //中文
    chineseName:/^[\u4e00-\u9fa5]+$/, //不限制字数中文
	chinese1:/[\u4E00-\u9FA5]/g, //非中文
	phone:/^1[3-9]\d{9}$/, //手机号码
	carded:/^[0-9a-zA-Z]+$/, //身份号码 （只允许数字和字母组合）
	creditCodeReg:/^[^_IOZSVa-z\W]{2}\d{6}[^_IOZSVa-z\W]{10}$/g, //统一社会信用代码
	url:/^([hH][tT]{2}[pP]:\/\/|[hH][tT]{2}[pP][sS]:\/\/)(([A-Za-z0-9-~]+)\.)+([A-Za-z0-9-~\/])+$/, //网址
 	encoding:/^[0-9]\d{5}$/, //邮政编码
	email:/^\w+@[a-z0-9]+(\.[a-z]+){1,3}$/, //邮箱
	num:/^[0-9]*$/, //验证是否是整数
	parseFloat:/^\d+(\.\d+)?$/, //验证是否是数字
    //numFloat:/^(?=[\d.]{1,15})([1-9]\d{1,14}|\d)(\.\d\d)?$/,//15位数字且支持两位小数
    numFloat:/(^[1-9][0-9]{1,14}$)|(^[1-9][0-9]{1,13}[\.][\d]{1}$)|(^[1-9][0-9]{1,12}[\.][\d]{2}$)/,//15位数字且支持两位小数
	address:/^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\*\+,;=.]+$/, //接口地址
	signPass:/^(?=.*?[a-z])(?=.*?[A-Z])(?=.*?\d)(?=.*?[!#@*&.])[a-zA-Z\d!#@*&.]*$/, //大小写字母、数字、特殊字符组合
}
//login-校验用户名
checkout.userName = function(value){
	var reg = regular.userName;
	var msg = '';
	if(value==''){
		msg = '用户名不能为空';
	}else if(!reg.test(value)){
		msg = '用户名必须是6-16位字母、数字或两者组合';
	}
	return msg;
}
//login-校验密码
checkout.userPassword = function(value){
	var reg = regular.userPassword;
	var msg = '';
	if(value==''){
		msg = '密码不能为空';
	}else if(!reg.test(value)){
		msg = '密码必须是6-16位字母、数字或两者组合';
	}
	return msg;
}
//login-校验验证码
checkout.code = function(value){
	var reg = regular.code;
	var msg = '';
	if(value==''){
		msg = '验证码不能为空';
	}else if(!reg.test(value)){
		msg = '验证码必须是6位数字';
	}
	return msg;
}
/*
	参数
	{
		id:'1',
		type:'chinese',  //类型可以为空
		size:'200', //限制输入长度
		multiple:1000, //倍数
		area:[10000,200000], //金额区间
		name:'姓名',
		value:'',
		msg:'',
		placeholder:'请输入姓名',
		info:'姓名不能为空',
		required:true, //是否是必填项
		decimal, //小数点后保留位数
		areaNum, //区间限制
		zero, //限制输入零
	},
*/
//其他校验-引入
checkout.otherCheckout = function(item){
	if(item.required){ //为true的时候是必选项
		if(!item.value){
			item.msg = item.info;
		}else if(item.type){ //为true的时候有类型
			checkout.typeCheckout(item)
		}else{
			item.msg = '';
		}
		return item.msg;
	}else{ //不是必选项
		if(item.value && item.type){
			checkout.typeCheckout(item)
		}else{
			item.msg = '';
		}
		return item.msg;
	}
}
//添加类型校验
checkout.typeCheckout = function(item){
	if(item.type=='userName'){ //用户名
		var reg = regular.userName;
		if(!reg.test(item.value)){
			item.msg = '用户名必须是6-16位字母、数字或两者组合';
		}else{
			item.msg = '';
		}
	}else if(item.type=='password'){ //密码
		var reg = regular.userPassword;
		if(!reg.test(item.value)){
			item.msg = '密码必须是8-16位字母、数字、特殊字符至少包含两种';
		}else{
			item.msg = '';
		}
	}else if(item.type=='code'){ //验证码
		var reg = regular.code;
		if(!reg.test(item.value)){
			item.msg = '验证码必须是6位数字';
		}else{
			item.msg = '';
		}
	}else if(item.type=='bankAccount'){ //银行账户
		var reg = regular.bankAccount;
		if(!reg.test(item.value.replace(/^\s+|\s+$/g,""))){
			item.msg = '只能是数字且长度不能大于64位';
		}else{
			item.msg = '';
		}
	}else if(item.type=='chinese'){ //中文-姓名
		var reg = regular.chinese;

		if(!reg.test(item.value.replace(/^\s+|\s+$/g,""))){
			item.msg = '只能是汉字且长度不能大于64位';
		}else{
			item.msg = '';
		}
	}else if(item.type=='chineseName'){ //不限制字数中文
		var reg = regular.chineseName;
		if(!reg.test(item.value)){
			item.msg = '只能输入中文';
		}else{
			item.msg = '';
		}
	}else if(item.type=='phone'){ //手机号
		var reg = regular.phone;
		if(!reg.test(item.value.replace(/^\s+|\s+$/g,""))){
			item.msg = '手机号格式错误，请重新输入';
		}else{
			item.msg = '';
		}
	}else if(item.type=='email'){ //邮箱
		var reg = regular.email;
		if(!reg.test(item.value)){
			item.msg = '邮箱格式错误，请重新输入';
		}else{
			item.msg = '';
		}
	}else if(item.type=='size'){ //限制输入长度
		if(item.value.length>item.size){
			item.msg = item.name+'不能超过'+item.size+'字';
		}else{
			item.msg = '';
		}
	}else if(item.type=='multiple'){ //倍数
		var reg = regular.num;
		if(!reg.test(item.value)){
			item.msg = '请输入数字';
		}else if(item.value<item.area[0] || item.value>item.area[1]){
			item.msg = '请输入'+item.area[0]+'~'+item.area[1]+'范围金额';
		}else if(item.value%item.multiple != 0){
			item.msg = '请输入'+item.multiple+'的倍数';
		}else{
			item.msg = '';
		}
	}else if(item.type=='number'){ //只能输入整数
		var reg = regular.num;
		if(item.zero=='0'){
			if(!reg.test(item.value)){
				item.msg = '请输入整数';
			}else if(item.value==item.zero || item.value>240){
				item.msg = '不能为0且不大于240';
			}else{
				item.msg = '';
			}
		}else{
			if(!reg.test(item.value)){
				item.msg = '请输入整数';
			}else{
				item.msg = '';
			}
		}
	}else if(item.type=='numFloat'){ //15位数字且支持两位小数
		var reg = regular.numFloat;
        if(!reg.test(item.value.toString().replace(/^\s+|\s+$/g,""))){
            item.msg = '金额字段必须为数字,长度不能大于15位且支持两位小数';
        }else{
            item.msg = '';
        }
	}
    else if(item.type=='parseFloat'){ //只能输入数字
		if(item.decimal){
			var reg,num;
			if(item.decimal=='2'){ //不限制0-100
				reg = /^(\d+|\d+\.\d{1,2})$/;
				num = '两位';
			}else{
				reg = /^(\d+|\d+\.\d{1,4})$/;
				num = '四位';
			}
			if(!reg.test(item.value)){
				item.msg = '只能保留小数点后'+num;
			}else{
				item.msg = '';
			}
		}else if(item.areaNum){ //限制区间
			let reg = /^(\d+|\d+\.\d{1,4})$/;
			if(!reg.test(item.value)){
				item.msg = '区间为0-24并且保留四位小数';
			} else if (parseFloat(item.value)>parseFloat(item.areaNum)) {
				item.msg = '区间为0-24并且保留四位小数';
			}else{
				item.msg = '';
			}
		}else{
			var reg = regular.parseFloat;
			if(!reg.test(item.value)){
				item.msg = '请输入数字';
			}else{
				item.msg = '';
			}
		}
	}else if(item.type=='address'){ //接口地址
		var reg = regular.address;
		if(!reg.test(item.value)){
			item.msg = '请输入正确的地址';
		}else if(item.size && item.value.length>item.size){
			item.msg = item.name+'不能超过'+item.size+'字';
		}else{
			item.msg = '';
		}
	}else if(item.type=='signPass'){ //复杂密钥
		var reg = regular.chinese1;
		if(reg.test(item.value)){
			item.msg = '不能输入中文';
		}else if(item.size && item.value.length>item.size){
			item.msg = item.name+'不能超过'+item.size+'字';
		}else{
			item.msg = '';
		}
	}else if(item.type=='carded'){ //身份证号
		var reg = regular.carded;
		if(!reg.test(item.value)){
			item.msg = '请输入正确的身份证号';
		}else{
			item.msg = '';
		}
	}else if(item.type=='creditCodeReg'){ //统一社会信用代码
		var reg = regular.creditCodeReg;
		if(!reg.test(item.value)){
			item.msg = '请输入正确的统一社会信用代码';
		}else{
			item.msg = '';
		}
	}


}
//密码-两次密码输入比较
checkout.userManagePassword = function(opt){
	var reg = regular.userPassword;
	var msg = '';
	if(opt.value==''){
		msg = '密码不能为空';
	}else if(!reg.test(opt.value)){
		msg = '密码必须是6-16位字母、数字或两者组合';
	}else if(opt.value != opt.value1 && opt.value1){
		msg = '两次输入密码不一致';
	}
	return msg;
}

checkout.isSocialCreditCode = function(Code){//统一社会信用代码
    var patrn = /^[0-9A-Z]+$/;
    //18位校验及大写校验
    if ((Code.length != 18) || (patrn.test(Code) == false)) {
        return false;
    } else {
        // 92420100MA4AFD35HG 这个码下面规则就不匹配
        return true;
        var Ancode;//统一社会信用代码的每一个值
        var Ancodevalue;//统一社会信用代码每一个值的权重
        var total = 0;
        var weightedfactors = [1, 3, 9, 27, 19, 26, 16, 17, 20, 29, 25, 13, 8, 24, 10, 30, 28];//加权因子
        var str = '0123456789ABCDEFGHJKLMNPQRTUWXY';
        //不用I、O、S、V、Z
        for (var i = 0; i < Code.length - 1; i++) {
            Ancode = Code.substring(i, i + 1);
            Ancodevalue = str.indexOf(Ancode);
            total = total + Ancodevalue * weightedfactors[i];
            //权重与加权因子相乘之和
        }
        var logiccheckcode = 31 - total % 31;

        if (logiccheckcode == 31) {
            logiccheckcode = 0;
        }
        var Str = "0,1,2,3,4,5,6,7,8,9,A,B,C,D,E,F,G,H,J,K,L,M,N,P,Q,R,T,U,W,X,Y";
        var Array_Str = Str.split(',');
        logiccheckcode = Array_Str[logiccheckcode];

        var checkcode = Code.substring(17, 18);
        if (logiccheckcode != checkcode) {
            return false;
        } else {
            return true;
        }
    }
    return true;
}

export {checkout}
